import { render, staticRenderFns } from "./CurationFilterRequestLayout.vue?vue&type=template&id=3d0cdf68&scoped=true&"
import script from "./CurationFilterRequestLayout.vue?vue&type=script&lang=js&"
export * from "./CurationFilterRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cdf68",
  null
  
)

export default component.exports